module.exports = __webpack_public_path__ + "img/long-term-savings-insurance-filled.14158b4.png";